var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BosniaAndHerzegovina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.966,43.998C23.978,43.998,23.989,44,24,44s0.022-0.002,0.034-0.002H23.966z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M44,24c0-5.592-2.301-10.642-6-14.271v28.543C41.699,34.642,44,29.592,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M34.837,40.794L7.358,12.914C5.239,16.087,4,19.898,4,24c0,11.034,8.936,19.98,19.966,19.998h0.068 C28.018,43.992,31.721,42.809,34.837,40.794z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M38,38.271V9.729C34.392,6.189,29.454,4,24,4c-6.944,0-13.057,3.541-16.642,8.914l27.479,27.881 C35.975,40.058,37.037,39.216,38,38.271z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.714,17l0.529,1.128l1.185,0.181L8.571,19.19l0.201,1.239l-1.058-0.586l-1.058,0.586l0.201-1.239 L6,18.309l1.185-0.181L7.714,17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.143,20.429l0.529,1.128l1.185,0.181L12,22.618l0.201,1.239l-1.058-0.586l-1.058,0.586 l0.201-1.239l-0.857-0.881l1.185-0.181L11.143,20.429z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.571,23.857l0.529,1.128l1.185,0.181l-0.857,0.881l0.201,1.239L14.571,26.7l-1.058,0.586 l0.201-1.239l-0.857-0.881l1.185-0.181L14.571,23.857z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18,27.286l0.529,1.128l1.185,0.181l-0.857,0.881l0.201,1.239L18,30.128l-1.058,0.586l0.201-1.239 l-0.857-0.881l1.185-0.181L18,27.286z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.429,30.714l0.529,1.128l1.185,0.181l-0.857,0.881l0.201,1.239l-1.058-0.586l-1.058,0.586 l0.201-1.239l-0.857-0.881l1.185-0.181L21.429,30.714z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.857,34.143l0.529,1.128l1.185,0.181l-0.857,0.881l0.201,1.239l-1.058-0.586l-1.058,0.586 L24,36.333l-0.857-0.881l1.185-0.181L24.857,34.143z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.286,37.571l0.529,1.128L30,38.881l-0.857,0.881L29.344,41l-1.058-0.586L27.228,41l0.201-1.239 l-0.857-0.881l1.185-0.181L28.286,37.571z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BosniaAndHerzegovina);
export default __webpack_public_path__ + "static/media/icons8-bosnia-and-herzegovina.57d925f9f9795d4e0c0d1fbbad417c78.svg";
export { ForwardRef as ReactComponent };